


// import { ListAlt as ListAltIcon } from '@mui/icons-material';
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import HomeIcon from "@mui/icons-material/Home";
// import LogoutIcon from "@mui/icons-material/Logout";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import PendingActionsIcon from '@mui/icons-material/PendingActions';
// import SearchIcon from "@mui/icons-material/Search";
// import StoreIcon from "@mui/icons-material/Store";
// import PeopleIcon from "@mui/icons-material/People";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import React, { useEffect, useState } from "react";
// import { FaBullhorn } from "react-icons/fa";
// import { Link, useNavigate } from "react-router-dom";
// import { MdExpandLess, MdExpandMore } from "react-icons/md";
// import { MdReportProblem } from "react-icons/md";

// const Navbar = () => {
//   const navigate = useNavigate();
//   const [open, setOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [openCampaign, setOpenCampaign] = useState(false); // Dropdown for Complaints
//   const [openUpload, setOpenUpload] = useState(false); // Dropdown for Bulk Upload

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const token = localStorage.getItem("mangertoken");
//     if (!token) {
//       navigate("/ManagerLogin");
//     }
//   }, [navigate]);

//   const menus = [
//     { name: "Home", link: "/ManagerHome", icon: HomeIcon },
//     { name: "Brand campaigns", link: "/brandcampaigns", icon: FaBullhorn },
//     { name: "Influencers Requirements", link: "/request", icon: PeopleIcon },
//     { name: "Add Brand", link: "/AddNewBrand", icon: StoreIcon },
//     { name: "Add Influencer", link: "/AddNewInfluencer", icon: PersonAddIcon },
//     { name: "Plan and list", link: "/plan1", icon: ListAltIcon },
//     { name: "Search", link: "/search1", icon: SearchIcon },
//     { name: "Profile", link: "/ManagerProfile", icon: AccountCircleIcon },
//     { name: "affilates request", link: "/Manageraffilatesrequest", icon: PendingActionsIcon },
//   ];

//   const logout = () => {
//     try {
//       localStorage.clear();
//       sessionStorage.clear();
//       document.cookie.split(";").forEach((cookie) => {
//         const cookieName = cookie.split("=")[0].trim();
//         document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
//       });
//       window.open("https://smesh.in/", "_blank");
//     } catch (err) {
//       console.error("Error during logout:", err);
//       localStorage.clear();
//       sessionStorage.clear();
//       window.open("https://smesh.in/", "_blank");
//     }
//   };

//   if (isMobile) {
//     return null;
//   }

//   return (
//     <div className="relative flex">
//       <div
//         className={`${
//           open ? "w-72" : "w-20"
//         } bg-black p-5 pt-8 relative duration-300 transition-all`}
//         style={{ height: "1100px" }}
//         onMouseEnter={!isMobile ? () => setOpen(true) : null}
//         onMouseLeave={!isMobile ? () => setOpen(false) : null}
//       >
//         <img
//           src="/left-arrow.jpg"
//           className={`absolute cursor-pointer -right-3 top-9 w-7 border-2 rounded-full transition-transform duration-300 ${
//             !open && "rotate-180"
//           }`}
//           alt="Toggle Sidebar"
//           onClick={() => setOpen(!open)}
//         />

//         <div className="flex gap-x-4 items-center">
//           <img
//             src={
//               open
//                 ? "/logo-ico.png"
//                 : "/logo-icon.png"
//             }
//             className={`cursor-pointer transition-transform duration-500 ${
//               open && "rotate-[360deg]"
//             }`}
//             style={{ width: "190px", height: open ? "56px" : "45px" }}
//             alt="Logo"
//           />
//           <h1
//             className={`text-white font-medium text-xl transition-transform duration-200 ${
//               !open && "scale-0"
//             }`}
//           ></h1>
//         </div>

//         <ul className="pt-6">
//           {menus.map((menu, index) => (
//             <li
//               key={index}
//               className="flex rounded-md p-2 cursor-pointer hover:bg-gray-700 text-gray-300 text-sm items-center gap-x-4 group"
//             >
//               <menu.icon
//                 className="w-5 h-5 group-hover:scale-125 transition-all duration-200"
//                 style={{ color: "white" }}
//               />
//               <Link
//                 to={menu.link}
//                 className={`transition-transform duration-200 ${
//                   !open && "hidden"
//                 }`}
//               >
//                 {menu.name}
//               </Link>
//             </li>
//           ))}

//           {/* === Bulk Upload Dropdown === */}
//           <li className="text-gray-300 text-sm">
//             <div
//               onClick={() => setOpenUpload(!openUpload)}
//               className="flex items-center justify-between rounded-md p-2 cursor-pointer hover:bg-gray-700 gap-x-4"
//             >
//               <div className="flex items-center gap-x-4">
//                 <CloudUploadIcon className="w-5 h-5" style={{ color: "white" }} />
//                 {open && <span>Bulk Upload</span>}
//               </div>
//               {open && (openUpload ? <MdExpandLess /> : <MdExpandMore />)}
//             </div>

//             {openUpload && open && (
//               <ul className="pl-10 mt-2 space-y-2">
//                 <li>
//                   <Link
//                     to="/upload"
//                     className="flex items-center gap-x-2 hover:text-white text-gray-400"
//                   >
//                     <PeopleIcon style={{ fontSize: 18 }} />
//                     Influencer CSV
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     to="/affilatecsv"
//                     className="flex items-center gap-x-2 hover:text-white text-gray-400"
//                   >
//                     <StoreIcon style={{ fontSize: 18 }} />
//                     Affiliate CSV
//                   </Link>
//                 </li>
//               </ul>
//             )}
//           </li>

//           {/* === Complaints Dropdown === */}
//           <li className="text-gray-300 text-sm">
//             <div
//               onClick={() => setOpenCampaign(!openCampaign)}
//               className="flex items-center justify-between rounded-md p-2 cursor-pointer hover:bg-gray-700 gap-x-4"
//             >
//               <div className="flex items-center gap-x-4">
//                 <MdReportProblem className="w-5 h-5" style={{ color: "white" }} />
//                 {open && <span>Compliants</span>}
//               </div>
//               {open && (openCampaign ? <MdExpandLess /> : <MdExpandMore />)}
//             </div>

//             {openCampaign && open && (
//               <ul className="pl-10 mt-2 space-y-2">
//                 <li>
//                   <Link
//                     to="/brandcomplaint"
//                     className="flex items-center gap-x-2 hover:text-white text-gray-400"
//                   >
//                     <StoreIcon style={{ fontSize: 18 }} />
//                     Brand
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     to="/allinfluencercomplaint"
//                     className="flex items-center gap-x-2 hover:text-white text-gray-400"
//                   >
//                     <PeopleIcon style={{ fontSize: 18 }} />
//                     Influencer
//                   </Link>
//                 </li>
//               </ul>
//             )}
//           </li>

//           {/* === Logout === */}
//           <li
//             key="logout"
//             className="flex rounded-md p-2 cursor-pointer hover:text-red-600 text-red-500 text-sm items-center gap-x-4"
//           >
//             <button
//               onClick={logout}
//               className="flex items-center p-2 w-full gap-x-4 cursor-pointer text-red-500 hover:text-red-600"
//             >
//               <LogoutIcon className="w-5 h-5" style={{ color: "red" }} />
//               <span className={`${!open && "hidden"} origin-left duration-200`}>
//                 Logout
//               </span>
//             </button>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Navbar;


import {
  AccountCircle as AccountCircleIcon,
  ArrowDropDown as ArrowDropDownIcon,
  Campaign as CampaignIcon,
  Logout as LogoutIcon,
  Store as StoreIcon,
  Person as PersonIcon,
  Settings as SettingsIcon,
  Handshake as HandshakeIcon
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// ===== Logo Component =====
const Logo = ({ open }) => (
  <div className="flex items-center gap-2 cursor-pointer">
    <img
      src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png"
      alt="Influenceso Logo"
      style={{ width: "45px", height: "auto" }}
    />
    {open && <span className="text-white font-semibold text-2xl mt-3">Influenceso</span>}
  </div>
);

const Navbar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("mangertoken");
    if (!token) navigate("/ManagerLogin");
  }, [navigate]);

  const menus = [
    { name: "Home", link: "/ManagerHome", icon: <CampaignIcon /> },
    { name: "Brand campaigns", link: "/brandcampaigns", icon: <CampaignIcon /> },
    { name: "Influencers Requirements", link: "/request", icon: <PersonIcon /> },
    { name: "Add Brand", link: "/AddNewBrand", icon: <StoreIcon /> },
    { name: "Add Influencer", link: "/AddNewInfluencer", icon: <PersonIcon /> },
    { name: "Plan and list", link: "/plan1", icon: <CampaignIcon /> },
    { name: "Search", link: "/search1", icon: <CampaignIcon /> },
    { name: "Profile", link: "/ManagerProfile", icon: <AccountCircleIcon /> },
    { name: "Affilates request", link: "/Manageraffilatesrequest", icon: <HandshakeIcon /> },
  ];

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
    window.open("https://www.influenceso.in/", "_blank");
  };

  // === MOBILE VIEW ===
  if (isMobile) return null;

  // === DESKTOP VIEW ===
  return (
    <div
      className={`bg-black text-white h-screen p-5 pt-8 transition-all duration-300 ${open ? "w-72" : "w-20"}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <Logo open={open} />
      <ul className="pt-6">
        {menus.map((menu, i) => (
          <li key={i} className="mb-4">
            <button
              onClick={() => navigate(menu.link)}
              className="flex items-center p-2 w-full rounded hover:bg-gray-700"
            >
              {menu.icon}
              {open && <span className="ml-3">{menu.name}</span>}
            </button>
          </li>
        ))}

        <li>
          <button onClick={logout} className="flex items-center p-2 w-full rounded hover:bg-gray-700 text-red-500">
            <LogoutIcon />
            {open && <span className="ml-3">Logout</span>}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;